<template>
    <div class="qingwu">
        <el-carousel :height="height">
            <el-carousel-item v-for="(v,k) in list" :key="k">
                <div class="shop_banner" :style="'background-position: center;background-image:url('+ filePath + v.adImage+');'"><router-link :to="v.adUrl||'#'"><div style="width:1200px;height:450px;display:block;"></div></router-link></div>
            </el-carousel-item>
        </el-carousel>




    </div>
</template>

<script>
export default {
    components: {},
    props: {
        list:{
            //imgPath:'http://192.168.0.57:8011/',
            adImage:null,
        },
        height:{
            type:String,
            default:'480px',
        },
    },
    data() {
      return {
          filePath:null,
      };
    },
    watch: {},
    computed: {},
    methods: {
        //附件路径
        filepath:function(){ 
             this.$get(this.$api.filepath,{platId:this.$platId}).then(res=>{
                this.filePath = res.data[0].config;
            });
        },
    },
    created() {
        this.filepath();
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>
.qingwu{
  box-shadow: 0 5px 10px 0 rgba(200, 200, 200, 0.5);
}
.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
}
.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
}
.shop_banner{
    height: 100%;
    background-position: center;
}
</style>